import Text from "components/base/Text";
import Trans from "components/base/Trans";
import { MotionBox as Box, blogFadeIn as fadeIn } from "utils/motion";

export default function NoResults({ messageId, bgColor }) {
  return (
    <Box
      textAlign="center"
      py={48}
      bg={bgColor}
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <Text>
        <Trans id={messageId} />
      </Text>
    </Box>
  );
}
